__turbopack_context__.v({
  "className": "JrthpG_className",
  "variable": "JrthpG_variable",
});
